import { isValidUuidV7 } from '@nudool/shared';
import { notFound } from '@tanstack/react-router';

/** Every `$…Id` URL segment is a UUIDv7 primary key, so a malformed one is a dead link and never reaches the API. */
export function assertUuidRouteParams(params: Record<string, string>): void {
  for (const [name, value] of Object.entries(params)) {
    if (name.endsWith('Id') && !isValidUuidV7(value)) throw notFound();
  }
}
